import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();

  // Extraire la langue de l'URL
  const pathParts = location.pathname.split('/');
  const currentLang = pathParts[1] || 'en'; // 'en' par défaut si aucune langue n'est trouvée
const { t, i18n } = useTranslation();
  return (
    <div className='account-navbar'>
      <Link to={`/${currentLang}/accountdetails`}>
        <Button variant="contained" className='account-navbar-button'>
          {t('accountmenu.myaccount')}
        </Button>
      </Link>
      <Link to={`/${currentLang}/accountaddress`}>
        <Button variant="contained" className='account-navbar-button'>
        {t('accountmenu.myaddresses')}
        </Button>
      </Link>
      <Link to={`/${currentLang}/accountorders`}>
        <Button variant="contained" className='account-navbar-button'>
        {t('accountmenu.myorders')}
        </Button>
      </Link>
      <Button 
        variant="contained" 
        className='account-navbar-button' 
        onClick={() => { localStorage.removeItem('auth-token'); window.location.replace(`/${currentLang}/`); }}
      >
        {t('accountmenu.logout')}
      </Button>
    </div>
  )
}

export default Navbar;
